// import request from '@/utils/request';

import axios from 'axios';
import qs from 'qs';

let request = axios.create();

var BASE_API = process.env.BASE_API || 'http://localhost:8080';
var EC_API = process.env.EC_API || 'http://localhost:3000';
var GOODS_API = EC_API + '/api';

export function getProductCategoryList(page) {
  return request({
    url: BASE_API + '/pmc/category/list',
    method: 'get'
  });
}

export function getProductOptionList(language) {
  return request({
    url: BASE_API + '/pmc/option/list',
    method: 'get'
  });
}

export function getProductList(page) {
  // console.log('xxx::API::getProductList', page);
  // let url = GOODS_API + '/goods/list' + (page ? '?page=' + page : '');
  let url = BASE_API + '/pmc/product/list' + (page ? '?page=' + page : '');

  // console.log('xxx::API::getProductList::url==', url);
  return request({
    url: url,
    method: 'get'
  });
}

export function getProduct(lang, skuId) {
  // let url = GOODS_API + '/goods/edit/' + lang + '/' + skuId,
  let url = BASE_API + '/pmc/product/' + lang + '/' + skuId;

  if (!skuId) skuId = '';
  return request({
    url: url,
    method: 'get'
  });
}

export function updateProduct(lang, skuId, data) {
  // let url = GOODS_API + '/goods/edit/' + lang + '/' + skuId;
  let url = BASE_API + '/pmc/product/' + lang;

  if (skuId) {
    url = url + '/' + skuId;
  }

  return request({
    url: url,
    method: 'post',
    data: data
  });
}

export function getColor2List() {
  let url = BASE_API + '/pmc/color2';
  return request({
    url: url,
    method: 'get'
  });
}



// WEBPACK FOOTER //
// ./src/api/pmc/product.js